export default "__VITE_ASSET__DHhfUsnY__"